
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { IAuth } from './auth.resource.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private authService: AuthService, private router: Router) { }

  addToken(req: HttpRequest<any>, token?: string): HttpRequest<any> {
    let copyReq;
    if (req.url.indexOf('api') !== -1) {
      if (!req.url.endsWith('auth/create')) {
        if (req.url.endsWith('auth/refresh')) {
          copyReq = req.clone({ headers: req.headers.set('refreshtoken', token || this.authService.getRefreshToken()) });
        } else {
          copyReq = req.clone({ headers: req.headers.set('accesstoken', token || this.authService.getAccessToken()) });
        }
        return copyReq;
      }
    }
    return req;
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpUserEvent<any>> {
    const authReq = this.addToken(req);

    return next.handle(authReq).pipe(catchError((error) => {
      if (!req.url.endsWith('auth/create')) {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 401:
              return this.handleRefresh(req, next);
          }
        }
      }
      return throwError(error);
    }));
  }


  handleRefresh(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    debugger;
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      this.authService.refreshToken().then((receivedAuth: IAuth) => {
        if (receivedAuth && receivedAuth.accesstoken) {
          this.tokenSubject.next(receivedAuth.accesstoken);
        } else {
          this.authService.logout();

        }
        this.isRefreshingToken = false;
      }, () => {
        this.authService.logout();

        this.isRefreshingToken = false;
      });
    }

    return this.tokenSubject
      .pipe(filter(token => token != null))
      .pipe(take(1))
      .pipe(switchMap(token => {
        return next.handle(this.addToken(req, token));
      }));
  }
}
